import { render, staticRenderFns } from "./ShopMenuIcon.vue?vue&type=template&id=6052de38&scoped=true&"
import script from "./ShopMenuIcon.vue?vue&type=script&lang=js&"
export * from "./ShopMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuIcon.vue?vue&type=style&index=0&id=6052de38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052de38",
  null
  
)

export default component.exports